import React from "react";
import { InlineWidget } from "react-calendly";

export const Calendly = ({ calendlyLink }) => {
  return <InlineWidget url={calendlyLink} />;
};
